module.exports = __webpack_public_path__ + "img/kakao_enterprise.02cd7ea3.png";